import React from 'react';

import { PrismicRichText } from 'types/prismicRichtext';
import { linkResolver } from 'utils/linkResolver';

import { asText, RichText } from 'components/rich-text/RichText';
import { DescriptiveList } from 'components/descriptive-list/DescriptiveList';
import { DescriptiveListItem } from 'components/descriptive-list/DescriptiveListItem';

import { ImageContainer } from './ImageContainer';
import { PrismicImage } from '../../types/prismicImage';
import { PrismicBodyDescriptiveListFields } from 'types/prismicSlices';

interface IDescriptiveListContainer {
  title: PrismicRichText;
  image?: PrismicImage;
  display?: string;
  items: PrismicBodyDescriptiveListFields[];
  isColumnLayout: boolean;
}

export const DescriptiveListContainer = ({
  title,
  image,
  isColumnLayout,
  items,
}: IDescriptiveListContainer) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <DescriptiveList
      title={title ? asText(title) : undefined}
      image={(image && <ImageContainer image={image} imageOnly />) || undefined}
      isColumnLayout={isColumnLayout}
    >
      {items.map((item: PrismicBodyDescriptiveListFields, i: number) => {
        return (
          <DescriptiveListItem
            key={i}
            title={asText(item.list_title)}
            text={<RichText>{item.text}</RichText>}
            footer={asText(item.footer)}
            link={linkResolver(item.link)}
          />
        );
      })}
    </DescriptiveList>
  );
};
